import TalentEngineInterviews from 'components/marketingSite/talentEngineV3/pages/TalentEngineInterviews';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type TalentEngineInterviewsPageProps = WithBaseUrl;

const TalentEngineInterviewsPage: React.FC<TalentEngineInterviewsPageProps> = ({
  baseUrl
}) => {
  const { t } = useI18n('talent-engine-interviews');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('talent-engine-interviews.page_title')}
        url={APP_URLS.talentEngineInterviews}
        desc={t('talent-engine-interviews.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_talent_engine.png'
        )}`}
        indexable={true}
      />
      <TalentEngineInterviews />
    </>
  );
};

export default TalentEngineInterviewsPage;

export const getStaticProps: GetStaticProps<
  TalentEngineInterviewsPageProps
> = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'talent-engine-interviews',
        'talent-engine-landing-v3'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
